module.exports = __webpack_public_path__ + "media/images/ecobanq-9e622f8d653dadc2463574724b00d9a8.png";